import React from 'react';
import necrolog from '../../images/necrolog.jpg';
// @ts-ignore
import gregory from '../../images/7.JPG';
// @ts-ignore
import taras from '../../images/6.JPG';
import materials from '../../images/materials.jpg';
import boscohistory from '../../images/boscohistory.jpg';
// @ts-ignore
import office from '../../images/office.jpeg';
import Heading from 'Heading';
// @ts-ignore
import CustomizedDialogs from 'components/dialog';

const MaterialsHistory = () => {
  return (
    <>
      <section 
// @ts-ignore
      className="pb-20 bg-orange ">
        <div 
// @ts-ignore
        className="container">
          <Heading name="Превентивна система" />
          <div 
// @ts-ignore
          className="flex flex-col justify-center w-full gap-5 md:flex-row md:gap-20">
            <a 
// @ts-ignore
            className="!flex w-full !border-0 !px-4 !py-4 !text-black !rounded-lg !bg-white !hover:underline text-2xl md:text-3xl justify-center" href="/preventivo-ua">
              <p 
// @ts-ignore
              className="text-md hover:underline"><h4>Превентивна система</h4></p>
            </a>
            <a 
// @ts-ignore
            className="!flex w-full !border-0 !px-4 !py-4 !text-black  !rounded-lg !bg-white !hover:underline text-2xl md:text-3xl justify-center" href="/preventivo-it">
              <p 
// @ts-ignore
              className="text-md hover:underline"><h4>Читати в оригіналі</h4></p>
            </a>

          </div>
        </div>
      </section>
      <section 
// @ts-ignore
      className="pb-20">
        <div 
// @ts-ignore
        className="container">
          <Heading name="Матеріали та історія" />
          <div 
// @ts-ignore
          className="grid grid-cols-1 gap-4 md:grid-cols-4">
            <a
              href="/don_bosco.pdf"
              target="_blank"
              rel="noopener noreferrer"
              // @ts-ignore
              className="relative">
              <div 
// @ts-ignore
              className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-10"></div>
              <p
                // @ts-ignore
                className="!rounded-tl-lg !rounded-br-lg !border-0 !normal-case !bg-[#A81414] !text-md md:!text-[20px] !py-1 !absolute !top-[0px] !left-[0px] !text-white !z-100 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
              >
                Література
              </p>
              <img 
// @ts-ignore
              className="!rounded-xl object-cover w-full h-60 " src={materials} alt="" />
              <img 
// @ts-ignore
              className="absolute bottom-0 right-0 !rounded-xl object-cover object-top w-[44px] h-[44px] " src={"images/link-to.png"} alt="" />

            </a>
            <a href="/istoriya-sv-ivana-bosko" 
// @ts-ignore
            className="relative ">
              <div 
// @ts-ignore
              className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-10"></div>
              <p
                // @ts-ignore
                className="!rounded-tl-lg !rounded-br-lg !border-0 !normal-case !bg-[#A81414] !text-md md:!text-[20px] !py-1 !absolute !top-[0px] !left-[0px] !text-white !z-100 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
              >
                Історія салезіянських святих
              </p>
              <img 
// @ts-ignore
              className="!rounded-xl object-cover w-full h-60 object-top" src={boscohistory} alt="" />
              <img 
// @ts-ignore
              className="absolute bottom-0 right-0 !rounded-xl object-cover object-top w-[44px] h-[44px] " src={"images/link-to.png"} alt="" />

            </a>

            <a href="/intrevyu-z-saleziyaninom" 
// @ts-ignore
            className="relative ">
              <div 
// @ts-ignore
              className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-10"></div>
              <p
                // @ts-ignore
                className="!rounded-tl-lg !rounded-br-lg !border-0 !normal-case !bg-[#A81414] !text-md md:!text-[20px] !py-1 !absolute !top-[0px] !left-[0px] !text-white !z-100 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
              >
                Інтерв'ю з салезіянином
              </p>
              <img 
// @ts-ignore
              className="!rounded-xl object-cover w-full h-60 " src={gregory} alt="" />
              <img 
// @ts-ignore
              className="absolute bottom-0 right-0 !rounded-xl object-cover object-center w-[44px] h-[44px] " src={"images/link-to.png"} alt="" />
            </a>
            <a
              href="/necrolog.pdf"
              target="_blank"
              rel="noopener noreferrer"
              // @ts-ignore
              className="relative">
              <div 
// @ts-ignore
              className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-10"></div>
              <p
                // @ts-ignore
                className="!rounded-tl-lg !rounded-br-lg !border-0 !normal-case !bg-[#A81414] !text-md md:!text-[20px] !py-1 !absolute !top-[0px] !left-[0px] !text-white !z-100 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
              >
                Некролог
              </p>
              <img 
// @ts-ignore
              className="!rounded-xl object-cover w-full h-60 object-right" src={necrolog} alt="" />
              <img 
// @ts-ignore
              className="absolute bottom-0 right-0 !rounded-xl object-cover object-top w-[44px] h-[44px] " src={"images/link-to.png"} alt="" />
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default MaterialsHistory;
